import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import classnames from 'classnames';
import get from 'lodash/get';
import toLower from 'lodash/toLower';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AccountPhoto as AccountPhotoIcon } from 'common/components/svgs';
import nationalities from '~variables/nationalities.json';
import { showPassportName } from '~helpers';

const ReconcilitionUserInfo = ({ userInfo }) => {
  const { t } = useTranslation();

  const getNationalitiesByCode = (code = null) => {
    const targetNationality = nationalities.list.find(nationality => nationality.code === code);
    return targetNationality ? targetNationality.name : '-';
  };

  return (
    <div
      className={classnames('reconciliation-user-info', {
        'reconciliation-user-info--loading': !userInfo,
      })}
    >
      <If condition={!userInfo}>
        <Spin />
      </If>
      <If condition={userInfo}>
        <div className="reconciliation-user-info__container">
          <div className="reconciliation-user-info__header">
            <AccountPhotoIcon className="reconciliation-user-info__account-photo" />
            <div className="reconciliation-user-info__base-info">
              <h3 className="reconciliation-user-info__name">{showPassportName(userInfo)}</h3>
              <p className="reconciliation-user-info__email">{get(userInfo, 'emailAddress')}</p>
            </div>
          </div>

          <div className="reconciliation-user-info__content">
            <div className="reconciliation-user-info__info-container">
              <p className="reconciliation-user-info__info-label">
                {t('landlord.booking.user_info.label.passport_number')}
              </p>
              <p className="reconciliation-user-info__info-value">
                {get(userInfo, 'passportNumber') || '-'}
              </p>
            </div>
            <div className="reconciliation-user-info__info-container">
              <p className="reconciliation-user-info__info-label">
                {t('landlord.booking.user_info.label.phone')}
              </p>
              <p className="reconciliation-user-info__info-value">
                {get(userInfo, 'phoneNumber') || '-'}
              </p>
            </div>
            <div className="reconciliation-user-info__info-container">
              <p className="reconciliation-user-info__info-label">
                {t('landlord.booking.user_info.label.birthday')}
              </p>
              <p className="reconciliation-user-info__info-value">
                {get(userInfo, 'dateOfBirth')
                  ? moment(get(userInfo, 'dateOfBirth')).format('DD/MM/YYYY')
                  : '-'}
              </p>
            </div>
            <div className="reconciliation-user-info__info-container">
              <p className="reconciliation-user-info__info-label">
                {t('landlord.booking.user_info.label.gender')}
              </p>
              <p className="reconciliation-user-info__info-value">
                {get(userInfo, 'gender')
                  ? t(`landlord.booking.user_info.value.gender.${toLower(get(userInfo, 'gender'))}`)
                  : '-'}
              </p>
            </div>
            <div className="reconciliation-user-info__info-container">
              <p className="reconciliation-user-info__info-label">
                {t('landlord.booking.user_info.label.nationality')}
              </p>
              <p className="reconciliation-user-info__info-value">
                {getNationalitiesByCode(get(userInfo, 'nationality'))}
              </p>
            </div>
            <div className="reconciliation-user-info__info-container">
              <p className="reconciliation-user-info__info-label">
                {t('landlord.booking.user_info.label.destination_university')}
              </p>
              <p className="reconciliation-user-info__info-value">
                {get(userInfo, 'destinationUniversity') || '-'}
              </p>
            </div>
          </div>
        </div>
      </If>
    </div>
  );
};

ReconcilitionUserInfo.propTypes = {
  userInfo: PropTypes.shape({
    passportFirstName: PropTypes.string,
    passportMiddleName: PropTypes.string,
    passportLastName: PropTypes.string,
    emailAddress: PropTypes.string,
    phoneNumber: PropTypes.string,
    dateOfBirth: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string,
    destinationUniversity: PropTypes.string,
    passportNumber: PropTypes.string,
  }),
};

ReconcilitionUserInfo.defaultProps = {
  userInfo: null,
};

export default ReconcilitionUserInfo;
